import { SimpleGrid } from '@mantine/core';
import { useContainerQuery } from 'src/UI/app-container/ContainerBreakpoint';
import { ProfileFormField } from '../components/ProfileFormField';
import { ProfileFormList } from '../components/ProfileFormList';
import EntityFormProvider from '../EntityFormProvider';

export default function Dependants() {
  const cq = useContainerQuery();
  const defaultFields = {
    first_name: '',
    last_name: '',
    relationship: '',
    date_of_birth: '',
    gender: '',
    is_financially_dependant: '',
  };

  return (
    <EntityFormProvider title="Dependants">
      <ProfileFormList entityType="Dependant" addButtonLabel="Add" defaultFields={defaultFields}>
        {index => (
          <SimpleGrid
            cols={cq({ base: 1, sm: 2, md: 3, lg: 6 })}
            style={{ alignItems: 'flex-end' }}
          >
            <ProfileFormField entityType="Dependant" fieldName="first_name" index={index} />
            <ProfileFormField entityType="Dependant" fieldName="last_name" index={index} />
            <ProfileFormField
              entityType="Dependant"
              fieldName="relationship"
              label="Relationship to client"
              index={index}
            />
            <ProfileFormField entityType="Dependant" fieldName="date_of_birth" index={index} />
            <ProfileFormField entityType="Dependant" fieldName="gender" index={index} />
            <ProfileFormField
              entityType="Dependant"
              fieldName="is_financially_dependant"
              index={index}
            />
          </SimpleGrid>
        )}
      </ProfileFormList>
    </EntityFormProvider>
  );
}
